export default class EmployeeSearchService {
  constructor(filterFilter) {
    'ngInject';

    Object.assign(this, { filterFilter });
  }

  onActiveEmployeesSearch(userGroups, searchValue, activeTab) {
    if (activeTab === 'employees') {
      return this.searchOnEmployeeTab(userGroups, searchValue);
    }

    if (activeTab === 'requests') {
      return this.searchOnRequestsTab(userGroups, searchValue);
    }

    if (activeTab === 'deactivated') {
      return this.searchOnDeactivatedTab(userGroups, searchValue);
    }

    return {
      employeesCount: 0,
      joinRequestsCount: 0,
      deactivatedCount: 0,
    };
  }

  searchOnEmployeeTab(userGroups, searchValue) {
    const employees = this.filterFilter(userGroups.regularUsers, { searchValue });
    const notInvitedUsers = this.filterFilter(userGroups.notInvitedUsers, { searchValue });
    const invitedUsers = this.filterFilter(userGroups.invitedUsers, { searchValue });

    if (employees.length || notInvitedUsers.length || invitedUsers.length) {
      return {
        employeesCount: employees.length + notInvitedUsers.length + invitedUsers.length,
        joinRequestsCount: 0,
        deactivatedCount: 0,
      };
    }

    // There is noone on active tab, time to show results from different tabs
    const joinRequests = this.filterFilter(userGroups.selfInvitedUsers, { searchValue });
    const deactivatedUsers = this.filterFilter(userGroups.deactivatedUsers, {
      searchValue,
    });

    return {
      employeesCount: 0,
      joinRequestsCount: joinRequests.length,
      deactivatedCount: deactivatedUsers.length,
    };
  }

  searchOnRequestsTab(userGroups, searchValue) {
    const joinRequests = this.filterFilter(userGroups.selfInvitedUsers, { searchValue });

    if (joinRequests.length) {
      return {
        employeesCount: 0,
        joinRequestsCount: joinRequests.length,
        deactivatedCount: 0,
      };
    }

    // There is noone on active tab, time to show results from different tabs
    const employees = this.filterFilter(userGroups.regularUsers, { searchValue });
    const notInvitedUsers = this.filterFilter(userGroups.notInvitedUsers, { searchValue });
    const invitedUsers = this.filterFilter(userGroups.invitedUsers, { searchValue });
    const deactivatedUsers = this.filterFilter(userGroups.deactivatedUsers, {
      searchValue,
    });

    return {
      employeesCount: employees.length + notInvitedUsers.length + invitedUsers.length,
      joinRequestsCount: 0,
      deactivatedCount: deactivatedUsers.length,
    };
  }

  searchOnDeactivatedTab(userGroups, searchValue) {
    const deactivatedUsers = this.filterFilter(userGroups.deactivatedUsers, {
      searchValue,
    });

    if (deactivatedUsers.length) {
      return {
        employeesCount: 0,
        joinRequestsCount: 0,
        deactivatedCount: deactivatedUsers.length,
      };
    }

    // There is noone on active tab, time to show results from different tabs
    const employees = this.filterFilter(userGroups.regularUsers, { searchValue });
    const notInvitedUsers = this.filterFilter(userGroups.notInvitedUsers, { searchValue });
    const invitedUsers = this.filterFilter(userGroups.invitedUsers, { searchValue });
    const joinRequests = this.filterFilter(userGroups.selfInvitedUsers, { searchValue });

    return {
      employeesCount: employees.length + notInvitedUsers.length + invitedUsers.length,
      joinRequestsCount: joinRequests.length,
      deactivatedCount: 0,
    };
  }
}
